import React, { useEffect, useState } from "react";
import styles from "./ReviewDetail.module.css";
import RecentPosts from "../recent-posts/RecentPosts";
import { API_BASE_URL } from "configs/AppConfig";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "components/page-content/common-component/Loader/Loader";
import SocialShareIcons from "components/page-content/case-studies/SocialShareIcons";
import MetaDetails from "components/meta-details/MetaDetails";
import SEO from "components/SEO/SEO";

export const formatDate = (dateString) => {
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    //   hour: "2-digit",
    //   minute: "2-digit",
    //   hour12: true,
  };

  const date = new Date(dateString);
  const formattedDate = date.toLocaleString("en-US", options).toUpperCase();

  // Replace only the last comma with ' AT'
  const finalDate = formattedDate.replace(/,(?!.*,)/, " AT");
  return finalDate.replace(/AT/, ",");
};

function ReviewDetail() {
  const [list, setList] = useState([]);
  const [reviewData, setReviewData] = useState({});
  const [upcomingData, setUpcomingData] = useState({});
  const [loading, setLoading] = useState(false);
  const { slug } = useParams();
  const navigate = useNavigate();
  console.log("slug value is", slug);
  console.log("review data", reviewData);
  const [data, setData] = useState();
  const [metaData, setMetaData] = useState();

  const fetchData = async () => {
    setLoading(true);
    const response = await fetch(
      `${API_BASE_URL}pages/get/all?category=6708c38c5e9b4984e1e2212e`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    setList(data?.data?.sort((a, b) => a.priority - b.priority));
    setLoading(false);
    console.log("data pages", data);

    if (data?.data?.[0]) {
      const pageData = data.data[0];
      setMetaData({
        pageTitle: pageData?.metatitle,
        description: pageData?.metadescription,
        pageKeyword: pageData?.metakeywords?.join(","),
      });
    }

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  const fetchReview = async () => {
    const response = await fetch(`${API_BASE_URL}pages/get/slug/${slug}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    setReviewData(data?.data[0]);
    console.log("data pages", data);

    if (data?.data?.[0]) {
      const pageData = data.data[0];
      setMetaData({
        pageTitle: pageData?.metatitle,
        description: pageData?.metadescription,
        pageKeyword: pageData?.metakeywords?.join(","),
      });
    }

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchReview();
  }, [slug]);

  useEffect(() => {
    if (reviewData && list?.length > 0) {
      const indexValue = list.findIndex((item) => item?._id == reviewData?._id);
      console.log("index value", indexValue);
      let previous = Number(indexValue) - 1;
      let next = Number(indexValue) + 1;
      if (Number(indexValue) == 0) {
        previous = list?.length - 1;
      }
      if (Number(indexValue) == list?.length - 1) {
        next = 0;
      }
      setUpcomingData({
        previous: previous,
        next: next,
      });
    }
  }, [reviewData, list]);

  const PreviousNext = ({ value, data }) => {
    console.log("data value is", data, upcomingData);
    return (
      <div
        onClick={() => navigate(`/reviews-and-blogs/${data?.slug}`)}
        className={styles.previousNext}
      >
        <h2>{value}</h2>
        <div className={styles.flexPortion}>
          <img src={data?.image} />
          <h3>{data?.name}</h3>
        </div>
      </div>
    );
  };
  console.log(metaData, "review detail metaData");
  return (
    <>
      {metaData && <SEO seo={metaData && metaData} />}
      <MetaDetails
        title={reviewData?.metatitle}
        description={reviewData?.metadescription}
        keywords={reviewData?.metakeywords?.join(", ")}
      />
      {loading ? (
        <Loader />
      ) : (
        <div className="review-detail">
          <div className={styles.detailOuter}>
            <div className={styles.contentImage}>
              <img className={styles.bannerImage} src={reviewData?.image} />
              <div className={styles.contents}>
                <p>
                  {/* {reviewData?.metatitle}&nbsp;/&nbsp; */}
                  {formatDate(reviewData?.createdAt)}&nbsp;/&nbsp;BY
                  BODYSHOPINDIA
                </p>
                <h1>{reviewData?.name}</h1>
                <SocialShareIcons
                  shareUrl={`${window.location.href}`}
                  title={reviewData.name}
                />
              </div>
            </div>
            <div className={styles.flexDiv}>
              <div className={styles.leftDiv}>
                <div
                  className={`${styles.htmlContent} html-content-space`}
                  dangerouslySetInnerHTML={{ __html: reviewData?.description }}
                ></div>
                <div className={styles.previousNextFlex}>
                  <PreviousNext
                    data={list[upcomingData?.previous]}
                    value="Previous"
                  />
                  <PreviousNext data={list[upcomingData?.next]} value="Next" />
                </div>
              </div>
              {/* <div className={styles.recentDiv}>
                <RecentPosts
                  list={list?.filter((item) => item?._id != reviewData?._id)}
                  background="#0096FF"
                  textColor="#FFF"
                />
              </div> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ReviewDetail;
